/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Landmark',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path d="M12.4 14.045a.6.6 0 1 1 0 1.2h-.8a.6.6 0 0 1 0-1.2h.8z" />
          <path
            fillRule="evenodd"
            d="M12.649 2.414c.552 0 .998.452 1.015 1.004.241 8.208 3.409 13.327 5.681 15.965.619.72.118 2.114-.805 2.2l-.09.004h-3.111l-.159-.013a1 1 0 0 1-.728-.524l-.062-.146-.544-1.633a1 1 0 0 0-.79-.671l-.158-.013h-1.559a1 1 0 0 0-.949.684l-.544 1.633-.062.146a1 1 0 0 1-.728.524l-.158.013H5.551l-.091-.004c-.923-.086-1.424-1.48-.805-2.2 2.272-2.637 5.439-7.757 5.681-15.965a1.03 1.03 0 0 1 .912-.999l.103-.005h1.298zm-1.12 1.2c-.286 8.412-3.542 13.73-5.945 16.528a.4.4 0 0 0 .028.18c.01.026.023.047.034.064h3.106l.499-1.495.062-.165a2.2 2.2 0 0 1 2.025-1.34h1.559a2.2 2.2 0 0 1 2.024 1.34l.063.165.498 1.495h2.872c.011-.017.024-.039.034-.064.026-.067.033-.131.029-.17-2.405-2.808-5.66-8.127-5.946-16.538h-.942z"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
